// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2MU5J","header":"ReportDetails_header__3L9be","title":"ReportDetails_title__q7PzK","left":"ReportDetails_left__2ADi2"};